/**
 * Transforms flat product data from the API into a grouped row structure
 * suitable for rendering in GroupedInventoryTable.
 *
 * @param {Array<Object>} products — Array of product records from API.
 *   Each product has: { id, codigoProveedor, marca, nombreProducto, pesoKg, porBodega }
 *   where porBodega is Record<number, { existencia, transito, vendidoUltimos30Dias, vendidoHistorico }>
 * @param {Array<{ idBodega: number, nombre: string }>} bodegas — Ordered bodega list
 * @returns {Array<ProductGroup>} — Array of product groups with bodega rows
 *
 * ProductGroup: {
 *   product: { id, codigoProveedor, marca, nombreProducto, pesoKg },
 *   bodegaRows: Array<{
 *     bodegaId: number,
 *     bodegaNombre: string,
 *     existencia: number,
 *     transito: number,
 *     vendidoUltimos30Dias: number,
 *     vendidoHistorico: number
 *   }>
 * }
 */
export function transformToGroupedRows(products, bodegas) {
  if (!products || !Array.isArray(products)) return [];
  if (!bodegas || !Array.isArray(bodegas) || bodegas.length === 0) return [];

  return products.map((product) => ({
    product: {
      id: product.idProducto ?? product.id,
      codigoProveedor: product.codigoProveedor,
      marca: product.marca,
      nombreProducto: product.nombreProducto,
      pesoKg: product.pesoKg,
    },
    bodegaRows: bodegas.map((bodega) => {
      const entry = product.porBodega?.[bodega.idBodega];
      return {
        bodegaId: bodega.idBodega,
        bodegaNombre: bodega.nombre,
        existencia: entry?.existencia ?? 0,
        transito: entry?.transito ?? 0,
        vendidoUltimos30Dias: entry?.vendidoUltimos30Dias ?? 0,
        vendidoHistorico: entry?.vendidoHistorico ?? 0,
      };
    }),
  }));
}
